"use client";
import React from "react";
import { Button, Stack, Link, useMediaQuery, Paper, Box } from "@mui/material";
import { useTranslations } from "next-intl";
import { CustomTypographyComponent } from "../ui/text";
import { ForgotPasswordForm, ForgotPasswordFormState } from "../index";
import { useTheme } from "@quales/utils/theme";
import axios from "axios";
import { isMobile } from "react-device-detect";
import { WcPaper, WcStack } from "@bpipartners/webui";
//import Logo from "../../../../assets/NovusLogo-transparant.png";

export const ForgotPasswordComposite = ({
  loginHost,
}: {
  loginHost: string;
}) => {
  const t = useTranslations();
  const forgotRef = React.useRef();
  const theme = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("md"));
  const [failedReset, setFailedReset] = React.useState<boolean>(false);
  const [isSubmitted, setIsSubmitted] = React.useState<boolean>(false);

  const handleForgotDetails = (val: ForgotPasswordFormState) => {
    if (val) {
      axios
        .post(
          loginHost + "/forgotPassword",
          { EmailAddress: val.userName },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            withCredentials: true,
          }
        )
        .then((res: any) => {
          if (res && res.data && res.data.Status === 200) {
            setIsSubmitted(true);
            setFailedReset(false);

            if (isMobile) {
              setTimeout(() => {
                //@ts-ignore
                window.ReactNativeWebView.postMessage("reset successful!");
              }, 2000);
            }
          } else {
            setFailedReset(true);
            setIsSubmitted(false);
          }
        })
        .catch((FEerror: any) => {
          setFailedReset(true);

          console.log("FE error", FEerror);
        });
    }
  };

  const handleForgotClicked = () => {
    if (forgotRef && forgotRef.current) {
      //@ts-ignore
      forgotRef.current.onSubmit();
    }
  };

  return (
    <WcPaper>
      <WcStack
        alignItems="center"
        height="600px"
        width={isSmallDevice ? "350px" : "600px"}
        id="ForgotPasswordComposite"
      >
        <WcStack padding={8}>
          <Box
            component="img"
            sx={{
              height: 100,
            }}
            //@ts-ignore
            alt={"Quales-logo"}
            src={"https://storage.googleapis.com/qualesstatic/quales-logo.png"}
          />
        </WcStack>
        <WcStack
          spacing={2}
          mt={2}
          justifyContent={"center"}
          alignItems="center"
          width="100%"
        >
          <CustomTypographyComponent variant="h5">
            {t("login.forgotPassword")}
          </CustomTypographyComponent>
          <CustomTypographyComponent textAlign={"center"}>
            {t("login.fillDetailsForgotPassword")}
          </CustomTypographyComponent>
        </WcStack>

        {failedReset && (
          <CustomTypographyComponent
            variant="body1"
            color={theme.appColors.error}
          >
            {t("login.failedPaswordReset")}
          </CustomTypographyComponent>
        )}
        {isSubmitted && !failedReset && (
          <CustomTypographyComponent
            variant="body1"
            textAlign={"center"}
            color={theme.palette.primary.main}
          >
            {t("login.succeededPaswordReset")}
          </CustomTypographyComponent>
        )}
        <WcStack justifyContent={"center"} alignItems="center" width="100%">
          <ForgotPasswordForm
            formDisabled={isSubmitted}
            onForgotPasswordDetails={handleForgotDetails}
            ref={forgotRef}
          />
        </WcStack>

        <WcStack>
          <WcStack alignItems={"center"} width="100%">
            <Button
              color="primary"
              variant="contained"
              disabled={isSubmitted}
              onClick={handleForgotClicked}
            >
              {t("login.resetPassword")}
            </Button>
          </WcStack>
        </WcStack>
        {!isSmallDevice && (
          <WcStack mt={4}>
            {isSubmitted && !failedReset && (
              <Link href="/login">
                <CustomTypographyComponent color={theme.palette.primary.main}>
                  {t("login.back2login")}
                </CustomTypographyComponent>
              </Link>
            )}
          </WcStack>
        )}
      </WcStack>
    </WcPaper>
  );
};

export default ForgotPasswordComposite;
